export const accordionPanelDetailsContainer = () => ({
  padding: 0,
});

export const accordionRoot = theme => ({
  '&:last-child': { borderRadius: 0 },
  backgroundColor: 'transparent',
  borderBottom: `1px solid ${theme.palette.gray.light}`,
  borderRadius: 0,
  boxShadow: 'none',
});

export const accordionTitle = () => ({
  padding: 0,
});

export const avatar = theme => ({
  '& > svg': {
    color: theme.palette.primary.dark,
  },
  backgroundColor: theme.palette.primary.light,
  height: 32,
  width: 32,
});

export const expandIcon = theme => ({
  color: theme.palette.primary.main,
});

export const legendItemsContainer = theme => ({
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
  display: 'grid',
  gridAutoRows: '1fr',
  gridRowGap: theme.spacing(2),
  height: '100%',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
    gridColumnGap: 0,
    gridTemplate: 'repeat(2, 1fr) / repeat(4, 1fr)',
  },
});
